<template>
  <!-- 彩色标签 -->
  <div class="zwx-sign" :style="signStyle">
    <div :style="signDivStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZwxSign",
  props: {
    innerHeight: { type: Number, required: false, default: 16 },
    innerFontSize: { type: Number, required: false, default: 10 },
    innerColor: { type: String, required: false, default: "#ffffff" },
    innerBgColor: { type: String, required: true },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {
    skin() {
      return this.$store.state.skin;
    },
    signStyle() {
      return `height: ${this.innerHeight}px !important;line-height: ${this.innerHeight}px !important; background: ${this.innerBgColor} !important; color: ${this.innerColor} !important;`;
    },
    signDivStyle() {
      return this.innerFontSize < 12
        ? `font-size: 12px !important; transform: scale(${this.innerFontSize /
            12}) !important;`
        : `font-size: ${this.innerFontSize}px !important;`;
    },
  },
  methods: {},
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.zwx-sign {
  display: inline-block !important;
  padding: 0 3px !important;
  font-family: "Harmony Medium", "Microsoft YaHei", "微软雅黑" !important;
  font-weight: 500 !important;
  letter-spacing: 0.5 !important;
  user-select: none !important;
  border-radius: 2px !important;
  div {
    height: 100% !important;
  }
}
</style>

<style lang="less"></style>
